(function() {
	'use strict';

	angular.module('quantixApp').controller('PortfolioMigrationController',
			PortfolioMigrationController);

	PortfolioMigrationController.$inject = [ '$scope', '$http', '$window',
			'$filter', 'PortMigrationService', 'ivhTreeviewBfs',
			'ivhTreeviewOptions', 'ivhTreeviewMgr' ];

	function PortfolioMigrationController($scope, $http, $window, $filter,
			PortMigrationService, ivhTreeviewBfs, ivhTreeviewOptions,
			ivhTreeviewMgr) {

		var vm = this;
		$scope.portMigrateTrackerGrid = [];

		$scope.restFilter = function() {
			$scope.getPortfolioMigrationDetails();
		}

		$scope.getPortfolioMigrationDetails = function() {

			var searchText = '';

			PortMigrationService.getPortfolioMigrationList().then(
					function(result) {

						$scope.portMigrateReportGridData = {

							dataProvider : result,
							delegate : $scope

						};
					});

		}

		$scope.portMigrateTrackerGridCompletion = function(event) {
			$scope.portMigrateTrackerGrid = event.target;
			$scope.portMigrateTrackerGrid.validateNow();
		};

		$scope.getPortActionData = function(item) {
			if(item.actionsButtons =="Initiate migration"){
			return ('<div id="port' +item.portfolioCode
					+ '"><a onClick="portMigartionActionW(this)">' + item.actionsButtons + '</a></div>');
			}
			else if(item.actionsButtons =="Re-migrate"){
				return ('<div id="port' +item.portfolioCode
						+ '"><a onClick="portMigartionActionW(this)">' + item.actionsButtons + '</a></div>');
				}
			else 
				return (item.actionsButtons);
		}

		$window.portMigartionActionW = function(item) {
			$scope
					.portMigartionAction(item.parentNode.parentNode.component.data);
		}
		$scope.portMigartionAction = function(portMigDetail) {
			PortMigrationService.portMigartionMovement(portMigDetail).then(
					function(resultData) {
						//document.getElementById("port"+portMigDetail.portfolioCode).innerHTML = 'Locked';
						
						console.log(resultData);
						$scope.getPortfolioMigrationDetails();
					}, function(errordata) {
						vm.entityResponse = errordata.data;
						$scope.errorMessage = vm.entityResponse.message;
						$scope.error = true;
						$timeout(function() {
							$scope.error = false;
							$scope.errorMessage = "";

						}, 2000);
					});
			
	

		}

		$scope.restFilter();

	}

})();
